import {
    Alert, Avatar, Button, Card, Col, DatePicker, Divider, Form,
    Image, Input, Modal, Row, Select, Spin, Table, Tag, Timeline, Typography
} from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { ExportReimbursementToExcel } from './export/ExportReimbursementToExcel';
import { dateFormat } from '../../Utils/formatDate';
import heic2any from "heic2any";

const { Option } = Select;

function ApprovalReimbursement() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [dateValue, setDateValue] = useState();
    const [textAlert, setTextAlert] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [detailData, setDetailData] = useState(null);
    const [isExportModalVisible, setIsExportModalVisible] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [rejectModalVisible, setRejectModalVisible] = useState(false);
    const [rejectReason, setRejectReason] = useState('');
    const [convertedImages, setConvertedImages] = useState([]);

    const [actionModalVisible, setActionModalVisible] = useState(false);
    const [actionStatus, setActionStatus] = useState('');
    const [actionReason, setActionReason] = useState('');
    const [bulkLoading, setBulkLoading] = useState(false);
    const [targetId, setTargetId] = useState(null);

    const titlePage = 'Reimbursement Data';
    useEffect(() => {
        const convertHeicImages = async () => {
            if (!detailData?.reimbursement_image) return;

            const results = await Promise.all(
                detailData.reimbursement_image.map(async (img) => {
                    try {
                        const url = img.image;

                        if (url?.toLowerCase().endsWith(".heic")) {
                            const response = await fetch(url, { mode: "cors" });
                            const blob = await response.blob();

                            const converted = await heic2any({
                                blob,
                                toType: "image/jpeg",
                                quality: 0.9,
                            });

                            return {
                                ...img,
                                convertedUrl: URL.createObjectURL(converted),
                            };
                        } else {
                            return { ...img, convertedUrl: url };
                        }
                    } catch (error) {
                        console.error("Gagal konversi HEIC:", error);
                        return { ...img, convertedUrl: img.image };
                    }
                })
            );

            setConvertedImages(results);
        };

        convertHeicImages();
    }, [detailData]);

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => {
                ++index;
                return (page.pagination.current - 1) * page.pagination.pageSize + index;
            },
        },
        {
            title: 'User Code',
            dataIndex: 'users_code',
            key: "users_code",
            render: (text, record) => record.users?.users_code,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            render: (text, record) => record.users?.name,
        },
        {
            title: 'Description',
            dataIndex: 'desc',
            key: "desc",
        },
        {
            title: 'Start Date',
            dataIndex: 'date_start',
            key: "date_start",
            render: (text, record) => <p>{moment(record.date_start).format('DD-MM-YYYY')}</p>,
        },
        {
            title: 'End Date',
            dataIndex: 'date_end',
            key: "date_end",
            render: (text, record) => <p>{moment(record.date_end).format('DD-MM-YYYY')}</p>,
        },
        {
            title: 'Approval By',
            dataIndex: 'user_approval',
            key: "user_approval",
            render: (text, record) => record.user_approval?.name || '-',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: "status",
            render: (text, record) => {
                switch (record.status) {
                    case 'Approved': return <Tag color='green'>{record.status}</Tag>;
                    case 'Rejected': return <Tag color='red'>{record.status}</Tag>;
                    default: return <Tag color='yellow'>{record.status}</Tag>;
                }
            }
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: "created_at",
            render: (text, record) => record.created_at ? <p>{dateFormat(record.created_at)}</p> : "-",
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <Button
                    type="default"
                    onClick={() => showDetailModal(record)}
                >
                    <b style={{ marginLeft: 5 }}>Detail</b>
                </Button>
            ),
        },
    ];

    useEffect(() => {
        getApi("GET", '/reimbursement?isDelegation=true&search=' + search + '&page=' + page.pagination.current + '&status=' + statusFilter, 'leave_paid');
    }, [JSON.stringify(page), search, isAlert, statusFilter]);

    const showDetailModal = (data) => {
        getApi('GET', '/reimbursement/' + data.reimbursement_id, 'detail');
    };

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                if (type === 'detail') {
                    setDetailData(res.data);
                    setIsModalVisible(true);
                } else if (type === 'export') {
                    const [start, end] = dateValue;
                    ExportReimbursementToExcel(res.data.data, start, end);
                    setIsExportModalVisible(false);
                } else {
                    setData(res.data.data);
                    setPage({
                        ...page,
                        pagination: {
                            ...page.pagination,
                            total: res.data.total_data
                        }
                    });
                }
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        });
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const handleExport = async () => {
        const [start, end] = dateValue;
        getApi("GET", '/reimbursement?nopage=true&startDate=' + start + '&endDate=' + end, 'export');
    };

    const handleBulkApproval = async (type) => {
        const statusId = type === 'approve' ? 2 : 3;
        const ids = selectedRows.map((row) => row.reimbursement_id);

        if (ids.length === 0) {
            modalError('No reimbursement selected.');
            return;
        }

        if (type === 'reject' && !rejectReason.trim()) {
            modalError('Please provide a reason for rejection.');
            return;
        }

        Modal.confirm({
            title: 'Confirmation',
            content: `Are you sure you want to ${type} the selected reimbursements?`,
            onOk: async () => {
                setLoading(true);
                try {
                    const dataReq = {
                        method: 'PUT',
                        url: '/reimbursementapprovalfinalbulk',
                        data: {
                            data: {
                                ids,
                                status_approval_id: statusId,
                                reason: type === 'reject' ? rejectReason : undefined,
                            },
                            headers: {
                                Authorization: 'Bearer ' + token,
                            },
                        },
                    };

                    const res = await apiCall(dataReq);
                    if (res.status === 'success') {
                        setTextAlert(res.message);
                        setIsAlert(true);
                        setRejectModalVisible(false);
                        setRejectReason('');
                        setSelectedRowKeys([]);
                        setSelectedRows([]);
                        getApi("GET", '/reimbursement?isDelegation=true&search=' + search + '&page=' + page.pagination.current, 'leave_paid');
                    } else {
                        modalError(res.message);
                    }
                } catch (e) {
                    modalError(e.message);
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const handleBulkReject = () => handleBulkApproval('reject');
    const handleActionSubmit = async () => {
        if (!actionStatus) {
            modalError("Please select status");
            return;
        }

        const payload = {
            status_approval_id: actionStatus === 'Approved' ? 2 : 3,
            reason: actionReason || '',
        };

        setBulkLoading(true);
        try {
            if (targetId) {
                await apiCall({
                    method: 'PUT',
                    url: `/reimbursementapprovalfinal/${targetId}`,
                    data: {
                        data: payload,
                        headers: { Authorization: 'Bearer ' + token },
                    },
                });
            } else {
                await apiCall({
                    method: 'PUT',
                    url: `/reimbursementapprovalfinalbulk`,
                    data: {
                        data: {
                            ids: selectedRowKeys,
                            ...payload,
                        },
                        headers: { Authorization: 'Bearer ' + token },
                    },
                });
            }

            setIsAlert(true);
            setTextAlert('Status berhasil diperbarui');
            setActionModalVisible(false);
            setIsModalVisible(false)
            setActionStatus('');
            setActionReason('');
            setSelectedRowKeys([]);
            setSelectedRows([]);
            setTargetId(null);
            getApi("GET", '/reimbursement?isDelegation=true&search=' + search + '&page=' + page.pagination.current, 'leave_paid');
        } catch (e) {
            modalError(e.message);
        } finally {
            setBulkLoading(false);
        }
    };

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Reimbursement Approval Data</h3>
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={8}>
                    <Select
                        placeholder="Filter by status"
                        allowClear
                        style={{ width: 160 }}
                        onChange={(val) => setStatusFilter(val || '')}
                    >
                        <Option value="Process">Process</Option>
                        <Option value="Approved">Approved</Option>
                        <Option value="Rejected">Rejected</Option>
                    </Select>
                    <Button onClick={() => setIsExportModalVisible(true)} style={{ marginLeft: 10 }}>
                        Export Excel
                    </Button>
                </Col>
                <Col span={8} style={{ textAlign: 'right' }}>
                    <Button
                        onClick={() => setActionModalVisible(true)}
                        disabled={selectedRowKeys.length === 0}
                    >
                        Action Bulk ({selectedRowKeys.length})
                    </Button>
                </Col>
            </Row>

            <Table
                rowSelection={{
                    selectedRowKeys,
                    onChange: (keys, rows) => {
                        setSelectedRowKeys(keys);
                        setSelectedRows(rows);
                    },
                    getCheckboxProps: (record) => ({
                        disabled: record.status !== 'Process',
                    }),
                }}
                rowKey="reimbursement_id"
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />

            <Modal
                title="Reimbursement Detail"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={900}
            >
                {loading ? (
                    <Spin tip="Loading..." style={{ display: "block", textAlign: "center" }} />
                ) : (
                    detailData && (
                        <Card>
                            <Typography.Title level={5}>Reimbursement Info</Typography.Title>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <Typography.Text strong>Code:</Typography.Text>
                                    <Typography.Paragraph>{detailData.reimbursement_code}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Description:</Typography.Text>
                                    <Typography.Paragraph>{detailData.desc}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Status:</Typography.Text>
                                    <Typography.Paragraph>{detailData.status}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Total:</Typography.Text>
                                    <Typography.Paragraph>Rp {detailData.total.toLocaleString()}</Typography.Paragraph>
                                </Col>
                            </Row>

                            <Divider />

                            <Typography.Title level={5}>Images</Typography.Title>
                            <Row gutter={[16, 16]}>
                                {convertedImages?.length > 0 ? (
                                    convertedImages.map((img) => (
                                        <Col key={img.reimbursement_image_id} span={6}>
                                            <Image
                                                alt={`Reimbursement ${img.reimbursement_image_id}`}
                                                src={img.convertedUrl}
                                                width={200}
                                                height={200}
                                                style={{
                                                    objectFit: "contain",
                                                    borderRadius: "10px",
                                                    border: '1px solid #F2F2F2'
                                                }}
                                            />
                                        </Col>
                                    ))
                                ) : (
                                    <Col span={24}>
                                        <Typography.Text>No reimbursement images</Typography.Text>
                                    </Col>
                                )}
                            </Row>


                            <Divider />

                            <Typography.Title level={5}>Items</Typography.Title>
                            <Row gutter={[16, 16]}>
                                {detailData.reimbursement_item.map((item) => (
                                    <Col span={24} key={item.reimbursement_item_id}>
                                        <Typography.Text strong>{item.item_name}</Typography.Text>
                                        <Typography.Paragraph>
                                            Total: Rp {item.total_submission.toLocaleString()}
                                        </Typography.Paragraph>
                                    </Col>
                                ))}
                            </Row>

                            <Divider />

                            <Typography.Title level={5}>Approval History</Typography.Title>
                            <Timeline mode="left" style={{ marginTop: 20 }}>
                                {/* Requested */}
                                <Timeline.Item color="blue">
                                    <Row gutter={8} align="middle">
                                        <Col>
                                            <Avatar src={detailData.users?.image} />
                                        </Col>
                                        <Col>
                                            <Typography.Text strong>{detailData.users?.name || "-"}</Typography.Text><br />
                                            <Tag color="blue">Requested</Tag><br />
                                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                {dateFormat(detailData.created_at) || "-"}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Timeline.Item>

                                {/* Approval Timeline */}
                                {detailData.reimbursement_approval.map((approval) => (
                                    <Timeline.Item
                                        key={approval.reimbursement_approval_id}
                                        color={
                                            approval.status_approval_id === 2
                                                ? "green"
                                                : approval.status_approval_id === 3
                                                    ? "red"
                                                    : "yellow"
                                        }
                                    >
                                        <Row gutter={8} align="middle">
                                            <Col>
                                                <Avatar src={approval.user?.image} />
                                            </Col>
                                            <Col>
                                                <Typography.Text strong>{approval.user?.name || "-"}</Typography.Text><br />
                                                {detailData.users.users_id === approval.user?.users_id ? (
                                                    <Tag color="red">Canceled</Tag>
                                                ) : (
                                                    <Tag
                                                        color={
                                                            approval.status_approval_id === 2
                                                                ? "green"
                                                                : approval.status_approval_id === 3
                                                                    ? "red"
                                                                    : "yellow"
                                                        }
                                                    >
                                                        {approval.status_approval?.status}
                                                    </Tag>
                                                )}
                                                <br />
                                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                    {dateFormat(approval.created_at) || "-"}
                                                </Typography.Text><br />
                                                {approval.reason && (
                                                    <Typography.Text italic style={{ fontSize: 12 }}>
                                                        Reason: {approval.reason}
                                                    </Typography.Text>
                                                )}
                                            </Col>
                                        </Row>
                                    </Timeline.Item>
                                ))}
                            </Timeline>
                            <Divider />

                            <div style={{ textAlign: 'right' }}>
                                <Button
                                    onClick={() => {
                                        setTargetId(detailData.reimbursement_id);
                                        setActionStatus('');
                                        setActionReason('');
                                        setTimeout(() => setActionModalVisible(true), 150);
                                    }}
                                >
                                    Change Status
                                </Button>
                            </div>
                        </Card>
                    )
                )}
            </Modal>

            <Modal
                title="Pilih Periode Export"
                open={isExportModalVisible}
                onCancel={() => setIsExportModalVisible(false)}
                onOk={() => handleExport()}
            >
                <Form layout="vertical">
                    <Form.Item
                        name="daterange"
                        label="Pilih Tanggal"
                        rules={[{ required: true, message: 'Harap pilih rentang tanggal' }]}
                    >
                        <DatePicker.RangePicker format="YYYY-MM-DD" value={dateValue} onChange={(e, ev) => setDateValue(ev)} />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Reject Selected"
                open={rejectModalVisible}
                onCancel={() => setRejectModalVisible(false)}
                onOk={handleBulkReject}
            >
                <Form layout="vertical">
                    <Form.Item label="Reason" required>
                        <Input.TextArea
                            rows={4}
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                        />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Approval Action"
                open={actionModalVisible}
                onCancel={() => {
                    setActionModalVisible(false);
                    setTargetId(null);
                    setActionStatus('');
                    setActionReason('');
                }}
                onOk={handleActionSubmit}
                okText={bulkLoading ? 'Processing...' : 'Submit'}
                okButtonProps={{ loading: bulkLoading }}
                zIndex={2000}
                getContainer={false}
            >
                <p>{targetId ? 'Set approval for this reimbursement' : `${selectedRowKeys.length} item(s) selected`}</p>
                <Select
                    placeholder="Select Status"
                    style={{ width: '100%', marginBottom: 12 }}
                    onChange={setActionStatus}
                    value={actionStatus}
                >
                    <Option value="Approved">Approved</Option>
                    <Option value="Rejected">Rejected</Option>
                </Select>
                <Input.TextArea
                    placeholder="Reason (optional)"
                    rows={3}
                    value={actionReason}
                    onChange={(e) => setActionReason(e.target.value)}
                />
            </Modal>

            <Modal
                title="Pilih Periode Export"
                open={isExportModalVisible}
                onCancel={() => setIsExportModalVisible(false)}
                onOk={() => handleExport()}
                zIndex={2000}
                getContainer={false}
            >
                <Form layout="vertical">
                    <Form.Item
                        name="daterange"
                        label="Pilih Tanggal"
                        rules={[{ required: true, message: 'Harap pilih rentang tanggal' }]}
                    >
                        <DatePicker.RangePicker format="YYYY-MM-DD" value={dateValue} onChange={(e, ev) => setDateValue(ev)} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default ApprovalReimbursement;
